export default "__VITE_ASSET__D82aj4KP__"